"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GamesService = void 0;
var _ = __importStar(require("lodash"));
var config_1 = require("../config/config");
var games_1 = require("../models/games");
var types_1 = require("../models/games/types");
var ticket_1 = require("../models/ticket");
var types_2 = require("../models/ticket/types");
var api_1 = require("./api");
var PATH = 'game/api';
var PATH_V1 = 'game/api/v1';
var PLAYER_PATH = 'game/player/api';
var GamesService = /** @class */ (function () {
    function GamesService() {
    }
    GamesService.getFeaturedGame = function (gameType) {
        return __awaiter(this, void 0, void 0, function () {
            var type, url, response, parsedGame, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        type = !!gameType || !!config_1.react_core_config.internalConfig.showGameTypeFilter ? gameType : config_1.react_core_config.internalConfig.instantGameType;
                        url = PATH + "/published-games?gameTypeId.in=" + type + "&page=0&size=1&sort=lastModifiedDate,desc";
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api_1.API.get({ url: url })];
                    case 2:
                        response = _a.sent();
                        parsedGame = {};
                        if (response.content && response.content.length) {
                            parsedGame = games_1.Game.JsonToGame(response.content[0]);
                        }
                        return [2 /*return*/, {
                                parsedGame: parsedGame
                            }];
                    case 3:
                        error_1 = _a.sent();
                        throw error_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    GamesService.getPublishedGames = function (page, size, sort, filter, type) {
        return __awaiter(this, void 0, void 0, function () {
            var gameType, requestParams, doFilter, url, response, parsedGames, last, totalPages, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        gameType = !!type || !!config_1.react_core_config.internalConfig.showGameTypeFilter ? type : config_1.react_core_config.internalConfig.instantGameType;
                        requestParams = "";
                        doFilter = filter !== null && filter !== undefined && filter.length > 0;
                        if (page) {
                            requestParams = "page=" + page + "&" + requestParams;
                        }
                        if (size) {
                            requestParams = "size=" + size + "&" + requestParams;
                        }
                        requestParams = sort ? "sort=" + sort + "&" + requestParams : "sort=lastModifiedDate,desc&excludeFeatured=" + !doFilter + "&" + requestParams;
                        if (doFilter) {
                            requestParams = filter + "&" + requestParams;
                            url = PATH + "/published-games?" + requestParams;
                            if (!!type && !url.includes('gameTypeId.in=')) {
                                url = PATH + "/published-games?gameTypeId.in=" + gameType + "&" + requestParams;
                            }
                        }
                        else {
                            url = PATH + "/published-games?gameTypeId.in=" + gameType + "&" + requestParams;
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api_1.API.get({ url: url })];
                    case 2:
                        response = _a.sent();
                        parsedGames = games_1.Game.JsonToGames(response.content);
                        last = doFilter ? response.last : Math.ceil((response.totalElements - 1) / response.size) <= response.number + 1;
                        totalPages = doFilter ? response.totalPages : Math.ceil((response.totalElements - 1) / response.size);
                        return [2 /*return*/, {
                                parsedGames: parsedGames,
                                page: {
                                    first: response.first,
                                    last: last,
                                    totalElements: response.totalElements,
                                    totalPages: totalPages,
                                    number: response.number
                                }
                            }];
                    case 3:
                        error_2 = _a.sent();
                        throw error_2;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    GamesService.getGameRetailPrices = function () {
        return __awaiter(this, void 0, void 0, function () {
            var requestUrl, response, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        requestUrl = PATH + "/published-games/price-points";
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api_1.API.get({
                                url: requestUrl
                            })];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, response];
                    case 3:
                        error_3 = _a.sent();
                        throw error_3;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    GamesService.getGameTypes = function () {
        return __awaiter(this, void 0, void 0, function () {
            var requestUrl, response, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        requestUrl = PATH + "/game-types";
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api_1.API.get({
                                url: requestUrl
                            })];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, response];
                    case 3:
                        error_4 = _a.sent();
                        throw error_4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    GamesService.getGameTagTypes = function () {
        return __awaiter(this, void 0, void 0, function () {
            var requestUrl, response, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        requestUrl = PATH + "/game-tag-types";
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api_1.API.get({
                                url: requestUrl
                            })];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, response];
                    case 3:
                        error_5 = _a.sent();
                        throw error_5;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    GamesService.getGameTags = function () {
        return __awaiter(this, void 0, void 0, function () {
            var requestUrl, response, error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        requestUrl = PATH + "/game-tags";
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api_1.API.get({
                                url: requestUrl
                            })];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, response];
                    case 3:
                        error_6 = _a.sent();
                        throw error_6;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    GamesService.getPublishedGame = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var response, error_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api_1.API.get({
                                url: PATH + "/published-games/" + id
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, games_1.Game.JsonToGame(response)];
                    case 2:
                        error_7 = _a.sent();
                        throw error_7;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    GamesService.getPrizesForGame = function (gameId) {
        return __awaiter(this, void 0, void 0, function () {
            var error_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api_1.API.get({
                                url: PATH + "/published-games/" + gameId + "/prizes"
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_8 = _a.sent();
                        throw error_8;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    GamesService.enterTicket = function (ticketNumber, validationCode) {
        return __awaiter(this, void 0, void 0, function () {
            var body, error_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        body = validationCode ? { ticketNumber: ticketNumber, validationCode: validationCode } : { ticketNumber: ticketNumber };
                        return [4 /*yield*/, api_1.API.post({
                                url: PATH + "/ticket-entries/manual",
                                body: body
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_9 = _a.sent();
                        throw error_9;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    GamesService.enterTicketBarCode = function (ticketBarCode) {
        return __awaiter(this, void 0, void 0, function () {
            var error_10;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api_1.API.post({
                                url: PATH + "/ticket-entries/scan",
                                body: {
                                    ticketBarCode: ticketBarCode
                                }
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_10 = _a.sent();
                        throw error_10;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    GamesService.enterTicketV2 = function (ticketNumber, validationCode) {
        return __awaiter(this, void 0, void 0, function () {
            var body, error_11;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        body = validationCode ? { ticketNumber: ticketNumber, validationCode: validationCode } : { ticketNumber: ticketNumber };
                        return [4 /*yield*/, api_1.API.post({
                                url: PATH + "/v2/ticket-entries/manual",
                                body: body
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_11 = _a.sent();
                        throw error_11;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    GamesService.enterTicketBarCodeV2 = function (ticketBarCode) {
        return __awaiter(this, void 0, void 0, function () {
            var error_12;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api_1.API.post({
                                url: PATH + "/v2/ticket-entries/scan",
                                body: {
                                    ticketBarCode: ticketBarCode
                                }
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_12 = _a.sent();
                        throw error_12;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    GamesService.checkInstantTicketBarCode = function (barcode) {
        return __awaiter(this, void 0, void 0, function () {
            var error_13;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api_1.API.post({
                                url: PATH + "/ticket/check-instant",
                                body: {
                                    barcode: barcode
                                }
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_13 = _a.sent();
                        throw error_13;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    GamesService.checkDrawTicketBarCode = function (barcode) {
        return __awaiter(this, void 0, void 0, function () {
            var error_14;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api_1.API.post({
                                url: PATH + "/ticket/check-draw",
                                body: {
                                    barcode: barcode
                                }
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_14 = _a.sent();
                        throw error_14;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    GamesService.checkCashOnlineBarCode = function (barcode) {
        return __awaiter(this, void 0, void 0, function () {
            var error_15;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api_1.API.post({
                                url: PATH + "/ticket/check-cash-online",
                                body: {
                                    barcode: barcode
                                }
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_15 = _a.sent();
                        throw error_15;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    GamesService.checkCashInstantBarCode = function (barcode) {
        return __awaiter(this, void 0, void 0, function () {
            var error_16;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api_1.API.post({
                                url: PATH + "/ticket/check-cash-instant",
                                body: {
                                    barcode: barcode
                                }
                            }).then(function (response) { return response; })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_16 = _a.sent();
                        throw error_16;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    GamesService.getDrawsForGame = function (gameId, size, page, sort) {
        return __awaiter(this, void 0, void 0, function () {
            var requestParams, url, error_17;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        requestParams = "size=" + size + "&";
                        if (page) {
                            requestParams = "page=" + page + "&" + requestParams;
                        }
                        requestParams = sort ? "sort=" + sort + "&" + requestParams : "sort=end,desc&sort=name,asc&" + requestParams;
                        url = PATH + "/published-games/" + gameId + "/draws?" + requestParams;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api_1.API.get({
                                url: url
                            })];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_17 = _a.sent();
                        throw error_17;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    GamesService.getPromotionsForGame = function (gameId, size, page, sort) {
        return __awaiter(this, void 0, void 0, function () {
            var requestParams, url, response, last, totalPages, error_18;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        requestParams = "size=" + size + "&";
                        if (page) {
                            requestParams = "page=" + page + "&" + requestParams;
                        }
                        requestParams = sort ? "sort=" + sort + "&" + requestParams : "sort=end,desc&sort=name,asc&" + requestParams;
                        url = PLAYER_PATH + "/games/" + gameId + "/promotions?" + requestParams;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api_1.API.get({
                                url: url
                            })];
                    case 2:
                        response = _a.sent();
                        last = Math.ceil((response.totalElements - 1) / response.size) <= response.number + 1;
                        totalPages = Math.ceil((response.totalElements - 1) / response.size);
                        return [2 /*return*/, {
                                content: response.content,
                                page: {
                                    first: response.first,
                                    last: last,
                                    totalElements: response.totalElements,
                                    totalPages: totalPages,
                                    number: response.number
                                }
                            }];
                    case 3:
                        error_18 = _a.sent();
                        throw error_18;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    GamesService.getRelatedGames = function (gameId, numOfGames) {
        return __awaiter(this, void 0, void 0, function () {
            var response, error_19;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api_1.API.get({
                                url: PATH + "/published-games/" + gameId + "/related-games/" + numOfGames
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, games_1.Game.JsonToRelatedGames(response)];
                    case 2:
                        error_19 = _a.sent();
                        throw error_19;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    GamesService.getAllRelatedGames = function (gameId) {
        return __awaiter(this, void 0, void 0, function () {
            var response, error_20;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api_1.API.get({
                                url: PATH + "/published-games/" + gameId + "/related-games"
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, games_1.Game.JsonToRelatedGames(response)];
                    case 2:
                        error_20 = _a.sent();
                        throw error_20;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    GamesService.getEligibleGamesForDraw = function (drawId) {
        return __awaiter(this, void 0, void 0, function () {
            var response, error_21;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api_1.API.get({
                                url: PATH + "/draws/" + drawId + "/games"
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, games_1.Game.JsonToGames(response)];
                    case 2:
                        error_21 = _a.sent();
                        throw error_21;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    GamesService.fetchDrawsByIdsForTicket = function (ticketSubmissionPrizeDTOs) {
        return __awaiter(this, void 0, void 0, function () {
            var ids, ticketSubmissionPrizeDTOList_1, requestParams, response_1, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        ids = [];
                        if (ticketSubmissionPrizeDTOs && ticketSubmissionPrizeDTOs.length) {
                            ids = ticketSubmissionPrizeDTOs.filter(function (plb) { return plb.prizeType === types_2.PrizeType.ENTRY; }).map(function (p) { return p.externalId; });
                        }
                        ticketSubmissionPrizeDTOList_1 = new ticket_1.TicketSubmissionPrizeDTOList();
                        if (!(ids.length > 0)) return [3 /*break*/, 2];
                        requestParams = ids.join(',');
                        return [4 /*yield*/, api_1.API.get({
                                url: PATH + "/draws-by-ids?ids=" + requestParams
                            })];
                    case 1:
                        response_1 = _a.sent();
                        if (response_1) {
                            ticketSubmissionPrizeDTOs.forEach(function (prize) {
                                // @ts-ignore
                                var drawData = response_1.find(function (draw) { return draw.id === Number(prize.externalId) && prize.prizeType === types_2.PrizeType.ENTRY; });
                                // prize.draw = {
                                //   name: drawData ? drawData.name : null
                                // };
                                ticketSubmissionPrizeDTOList_1.push(prize);
                            });
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/, ticketSubmissionPrizeDTOList_1];
                    case 3:
                        e_1 = _a.sent();
                        throw e_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    GamesService.getGamesByIds = function (ids) {
        return __awaiter(this, void 0, void 0, function () {
            var url, error_22;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = PATH + "/games-by-ids?ids=" + ids;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api_1.API.get({ url: url })];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_22 = _a.sent();
                        throw error_22;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    GamesService.getGameConfig = function (gameId) {
        return __awaiter(this, void 0, void 0, function () {
            var e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api_1.API.get({
                                url: PATH + "/interactive/" + gameId
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        e_2 = _a.sent();
                        throw e_2;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    GamesService.updateGame = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var e_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api_1.API.put({
                                url: PATH + "/interactive/" + id
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        e_3 = _a.sent();
                        throw e_3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    GamesService.getLatestJackpotResultByGame = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var response, error_23;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api_1.API.get({
                                url: PATH + "/jackpot/" + id
                            })];
                    case 1:
                        response = _a.sent();
                        if (response) {
                            return [2 /*return*/, __assign(__assign({}, response), { gameNumbers: this.convertResultDataForKeno(response.resultData) })];
                        }
                        else {
                            return [2 /*return*/, {
                                    jackpotResult: null,
                                    resultData: [],
                                    gameNumbers: []
                                }];
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_23 = _a.sent();
                        throw error_23;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    GamesService.getJackpotResultByGameAndDraw = function (gameId, drawId) {
        return __awaiter(this, void 0, void 0, function () {
            var response, error_24;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api_1.API.get({
                                url: PATH + "/jackpot/" + gameId + "/" + drawId
                            })];
                    case 1:
                        response = _a.sent();
                        if (response) {
                            return [2 /*return*/, __assign(__assign({}, response), { gameNumbers: this.convertResultDataForKeno(response.resultData), currentDraw: drawId })];
                        }
                        else {
                            return [2 /*return*/, {
                                    jackpotResult: null,
                                    resultData: [],
                                    gameNumbers: [],
                                    currentDraw: drawId
                                }];
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_24 = _a.sent();
                        throw error_24;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    GamesService.sendPlayerTicketDataForJackpotGame = function (gameId, drawId, playerSpots, ticketCost) {
        return __awaiter(this, void 0, void 0, function () {
            var response, error_25;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api_1.API.post({
                                url: PATH + "/jackpot/" + gameId + "/" + drawId,
                                body: {
                                    ticketCost: ticketCost,
                                    playerSpots: playerSpots.join(',')
                                }
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, __assign(__assign({}, response), { gameNumbers: this.convertResultDataForKeno(response.resultData) })];
                    case 2:
                        error_25 = _a.sent();
                        throw error_25;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    GamesService.getMultipleDrawsPayout = function (gameId, drawIds, playerSpots, ticketCost) {
        return __awaiter(this, void 0, void 0, function () {
            var response, tempResponse, error_26;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api_1.API.post({
                                url: PATH + "/jackpot/" + gameId,
                                body: {
                                    ticketCost: ticketCost,
                                    playerSpots: playerSpots.join(','),
                                    drawNumbers: drawIds
                                }
                            })];
                    case 1:
                        response = _a.sent();
                        tempResponse = [];
                        if (response) {
                            tempResponse = response.map(function (item) {
                                item.gameNumbers = _this.convertResultDataForKeno(item.resultData);
                                return item;
                            });
                        }
                        return [2 /*return*/, tempResponse];
                    case 2:
                        error_26 = _a.sent();
                        throw error_26;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    GamesService.getLatestJackpotResultByStatus = function (gameId, status) {
        return __awaiter(this, void 0, void 0, function () {
            var e_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api_1.API.get({
                                url: PATH_V1 + "/jackpot-results/" + gameId + "/" + types_1.IJackpotStatus[status]
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        e_4 = _a.sent();
                        throw e_4;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    GamesService.getJackpotResultsForTheGame = function (gameId, status, page, size) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response, last, totalPages, recentDraw, error_27;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = PATH_V1 + "/jackpot-results?gameId.equals=" + gameId + "&jackpotStatus.equals=" + types_1.IJackpotStatus[status] + "&page=" + (page || 0) + "&size=" + (size || 9999) + "&sort=drawDate,desc";
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api_1.API.get({ url: url })];
                    case 2:
                        response = _a.sent();
                        last = Math.ceil((response.totalElements - 1) / response.size) <= response.number + 1;
                        totalPages = Math.ceil((response.totalElements - 1) / response.size);
                        recentDraw = response.content && response.content.length > 0 ? response.content[0] : {};
                        return [2 /*return*/, {
                                recentDraw: recentDraw,
                                content: response.content,
                                page: {
                                    first: response.first,
                                    last: last,
                                    totalElements: response.totalElements,
                                    totalPages: totalPages,
                                    number: response.number
                                }
                            }];
                    case 3:
                        error_27 = _a.sent();
                        throw error_27;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    GamesService.convertResultDataForKeno = function (resultData) {
        var sorted = _.orderBy(resultData, ['order']).filter(
        // @ts-ignore
        function (item) { return item.type === types_1.IJackpotGameResultDataType[types_1.IJackpotGameResultDataType.REGULAR]; });
        return _.map(sorted, 'data').map(function (item) { return parseInt(item, 10); });
    };
    return GamesService;
}());
exports.GamesService = GamesService;
//# sourceMappingURL=games-service.js.map